var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "50%",
    cy: "50%",
    r: "45%",
    stroke: "#fff",
    strokeWidth: 2,
    vectorEffect: "non-scaling-stroke"
  })));
}
export default SvgCircle;